(function($) {
  var w = 0;

  $(window).load(function() {
    w = $(window).width();
  });

  $(document).ready(function() {
    var $style = $("<style />");
    $style.text(
      ".mainNavSecondaryUl .auto-generated-list-item {display:none!important;}"
    );
    $("head").append($style);

    $(".mainNav li:has(ul)").each(function() {
      var name = $(this)
        .children("a")
        .data("name");
      var href = $(this)
        .children("a")
        .attr("href");
      var text = $(this)
        .children("a")
        .text();
      var $sub = $(this).children("ul");
      var $a = $("<a />");
      var $li = $("<li />").addClass("auto-generated-list-item");
      $li.prepend('<span class="fa fa-home fa-fw"></span>');
      if (!$sub.find('li a[href="' + href + '"]').length) {
        $a.attr("href", href)
          .data("name", name)
          .text(text);
        $a.attr("data-analytics-control", "Header Menu");
        $a.attr("data-analytics-controlid", text);
        $li.append($a);
        $sub.prepend($li);
      }
    });
    // console.log("Test");
    $(".mainNav li.topLevelLink:not(ul)").each(function() {
      if (!$(this).children("ul").length) {
        $(this).append("<ul></ul>");
      }
      var name = $(this)
        .children("a")
        .data("name");
      var href = $(this)
        .children("a")
        .attr("href");
      var text = $(this)
        .children("a")
        .text();
      var $sub = $(this).children("ul");
      var $a = $("<a />");
      var $li = $("<li />").addClass("auto-generated-list-item");
      $li.prepend('<span class="fa fa-home fa-fw"></span>');
      if (!$sub.find('li a[href="' + href + '"]').length) {
        $a.attr("href", href)
          .data("name", name)
          .text(text);
        $a.attr("data-analytics-control", "Header Menu");
        $a.attr("data-analytics-controlid", text);
        $li.append($a);
        $sub.prepend($li);
      }
    });
  });

  $(document).ready(function() {
    var topHREF = $(".mainNav li.locator")
      .children("a")
      .attr("href");
    var topText = $(".mainNav li.locator")
      .children("a")
      .text();
    var $topA = $("<a />");
    var $topLI = $("<li />").addClass("auto-generated-list-item");
    var $topSub = $(".mainNavLocatorContainer").children("ul");

    $topA.attr("href", topHREF).text(topText);
    $topLI.append($topA);
    $topSub.prepend($topLI);

    $(".mainNavLocatorContainer li:has(ul)").each(function() {
      var name = $(this)
        .children("a")
        .data("name");
      var href = $(this)
        .children("a")
        .attr("href");
      var text = $(this)
        .children("a")
        .text();
      var $sub = $(this).children("ul");
      var $a = $("<a />");
      var $li = $("<li />").addClass("auto-generated-list-item");
      $li.prepend('<span class="fa fa-home fa-fw"></span>');
      if (!$sub.find('li a[href="' + href + '"]').length) {
        $a.attr("href", href)
          .data("name", name)
          .text(text);
        $li.append($a);
        $sub.prepend($li);
      }
    });
  });

  $(document).ready(function() {
    $(".locator").on("click", function() {
      var chapterName = $(this)
        .find(">a")
        .data("name");
      var $chapterMenu = $(".mainNav-subContainer.on");
      if (chapterName && $chapterMenu.length) {
        $chapterMenu.find(".mainNavCrumbsInner > a").text(chapterName);

        $chapterMenu
          .find(".auto-generated-list-item > a")
          .first()
          .text(chapterName);
      }
    });
  });

  $(document).ready(function() {
    var overallHeight = $(window).height(),
      overallWidth = $(window).width(),
      sm = 576,
      md = 768,
      lg = 992,
      xl = 1200,
      xxl = 1400;
    var menuToggleHeight = $(".menuToggle").outerHeight(true);

    $(window).on("resize", function() {
      if (w != $(window).width()) {
        overallHeight = $(window).height();
        overallWidth = $(window).width();

        placeNav();
        placeTopLinks();
        cleanUpLinks();

        w = $(window).width();
      }
    });

    // PLACE NAV
    function placeNav() {
      if (overallWidth < md) {
        $(".mainNav").css({
          top: menuToggleHeight
        });
        $(".mainNav").insertAfter("header");
      } else {
        $(".mainNav").css({
          top: 0
        });
        $(".mainNav").insertAfter("header .container-fluid");
      }
    }
    placeNav();

    // PLACE SEARCH
    function placeSearch() {
      if (overallWidth < md) {
        $(".mainSearch").prependTo(".mainNav");
      } else {
        $(window).on("resize", function() {
          $(".mainSearch").prependTo(".mainNav");
        });
      }
    }
    placeSearch();
	
    // PLACE TOP LINKS
    var topLevelLength = $(".mainNav-inner > ul li").length;

    function placeTopLinks() {
      if (overallWidth < md) {
        $(".mainNav-inner > ul li")
          .slice(topLevelLength)
          .remove();
        $(".topLinks li")
          .clone(true)
          .addClass("mainNavTopLink")
          .appendTo(".mainNav-inner > ul");
      } else {
        $(".mainNav-inner > ul li")
          .slice(topLevelLength)
          .remove();
      }
    }
    placeTopLinks();

    // CLEAN UP LINKS ON RESIZE
    function cleanUpLinks() {
      $(".mainNavSecondaryUl").remove();
    }

    // HIDE OR SHOW MAIN NAV SHADE
    //The below code breaks the mobile experience so changing it to work only if window become larger than mobile.
    $(window).on("resize", function() {
      if (overallWidth > md) {
        $(".mainNavShade").removeClass("on");
        $(".headerDonateBtn").removeClass("shade");
        $(".mainNav").removeClass("on");
        $(".menuToggle").removeClass("on");
        $(".mainNav-subContainer").removeClass("on");
        $(".mainNav-subContainer").css("display", "none");
        $(".mainNav-inner ul li").removeClass("on");
        $("html").removeClass("stuck");
        $("body").removeClass("stuck");
        $(".menuToggle span").text(menuToggleText);
      }
    });

    $(".mainNavShade").click(function() {
      subContainerClose();
      mobileMenuClose();
    });

    // MENU TOGGLE
    var menuToggleText = $(".menuToggle span").text();

    $(".menuToggle").click(function() {
      if (!$(this).hasClass("on")) {
        $(".mainNav").addClass("on");
        $(".mainNavShade").addClass("on");
        $(this).addClass("on");
        $("span", this).text("close");
        $(".headerDonateBtn").addClass("shade");
        $("html, body").addClass("stuck");
        $('.mainNavSecondaryUl[class*="mainNav-level"]').remove();
      } else {
        mobileMenuClose();
      }
    });

    function mobileMenuClose() {
      $(".mainNav").removeClass("on");
      $(".mainNavShade").removeClass("on");
      $(".menuToggle").removeClass("on");
      $(".menuToggle span").text(menuToggleText);
      $('.mainNavSecondaryUl[class*="mainNav-level"]').remove();
      $(".mainNav ul")
        .first()
        .css({
          marginLeft: 0
        });
      currentLevel = 0;
      $(".headerDonateBtn").removeClass("shade");
      $("html, body").removeClass("stuck");
	  
	  // Dean note: 11/9/2023 added this additional code to remove the chapter cloned menu because that gets created differently than the other submenus
      $(".clonedChapterMenu").remove();	  
    }

    $(window).on("resize", function() {
      if (w != $(window).width()) {
        mobileMenuClose();
        w = $(window).width();
      }
    });

    var currentChannel;
    var currentLevel = 0;

    // MOBILE NAV LINKS
    $(".mainNav ul li a").click(function(e) {
      // MOBILE FUNCTIONS
      if (overallWidth < md) {
		// Dean note: 4/10/2023 old code below commented out and replaced with the code below.
        // currentLevel++;
		
		// Dean note: check to see if link is a submenu item first.  If it is a submenu, then increment the currentLevel count which keeps track of how deep the user is 
		// within the navigation tree.  If it is not a submenu item - i.e. it is just a regular link, then don't increment the count. 
		// This is to fix a bug where some links open up in a new window or if users use ctrl + click to open it up the link in a new tab. 
		// Dean note: 11/9/2023 added additional condition to check that this doesn't have the class "locator" to ensure that 
		// it doesn't include the "Your Chapter" link because that is the only one that doesn't have a submenu but still expands
		// to create a sub menu. 
		if ($(this).closest("li").hasClass("hasChildren") || $(this).text().toLowerCase() == "your chapter")
		{
			currentLevel++;
		}
		
		
        if (
          $(this)
            .closest("li")
            .hasClass("locator") &&
          $(this).attr("data-name") != "Chapter Menu"
        ) {
          e.preventDefault();

          var $ul = $(".mainNavLocatorContainer > ul").clone(true);

          $ul.find("li:first-child").remove();
          $(this)
            .parent("li")
            .find("> ul")
            .remove();
          $(this)
            .parent("li")
            .append($ul);

          $(".mainNav").scrollTop(0);

		  // Dean note: 11/9/2023 added the class "clonedChapterMenu" to uniquely identify this chapter menu so that we can remove it if the user clicks on the close button
          $(this)
            .parent("li")
            .find("> ul")
            .clone(true)
            .addClass("mainNavSecondaryUl clonedChapterMenu")
            .insertAfter($(this).closest("ul"));
          $(".mainNav ul")
            .first()
            .css("marginLeft", "-" + currentLevel * 100 + "%");
          $(".mainNav ul")
            .first()
            .addClass("mainNavSecondaryUl");

          $(this)
            .closest("li")
            .clone()
            .prependTo(
              $(this)
                .closest("ul")
                .next("ul")
            );

          $(this)
            .closest("ul")
            .next("ul")
            .prepend(
              '<li><a class="mainNavMobileBack" href="#">Go Back</a></li>'
            );
        } else if (
          $(this)
            .closest("li")
            .find("> ul").length
        ) {
          e.preventDefault();

          $(".mainNav").scrollTop(0);

          $(this)
            .parent("li")
            .find("> ul")
            .clone(true)
            .addClass("mainNavSecondaryUl")
            .insertAfter($(this).closest("ul"));
          $(".mainNav ul")
            .first()
            .css({
              marginLeft: "-" + currentLevel * 100 + "%"
            });
          $(".mainNav ul")
            .first()
            .addClass("mainNavSecondaryUl");
          $(this)
            .parent()
            .parent("ul")
            .next("ul")
            .addClass("mainNav-level" + currentLevel);
          $(this)
            .parents(".mainNav-inner")
            .addClass("has-levels");
          $(this)
            .closest("li")
            .clone()
            .prependTo(
              $(this)
                .closest("ul")
                .next("ul")
            );

          $(this)
            .closest("ul")
            .next("ul")
            .prepend(
              '<li><a class="mainNavMobileBack" href="#">Go Back</a></li>'
            );

          var thisImage = $(this)
            .next("div._advertisementContent")
            .clone();
          $(".mainNavSubRight").html(thisImage.html());
        }
      }
    });

    function mainNavMobilePrev() {
      currentLevel = currentLevel - 1;

      $(".mainNav").scrollTop(0);
      $(".mainNav ul")
        .first()
        .css({
          marginLeft: "-" + currentLevel * 100 + "%"
        });
      $(".mainNavSecondaryUl")
        .last()
        .remove();
    }

    $(".mainNav").swiperight(function(e) {
      e.preventDefault();
      mainNavMobilePrev();
    });

    $(document.body).on("click", ".mainNavMobileBack", function(e) {
      e.preventDefault();
      mainNavMobilePrev();
    });

    $(document.body).on("click", ".mainNav-level1 .mainNavMobileBack", function(
      e
    ) {
      $(".mainNav-inner").removeClass("has-levels");
    });
    // TOP LEVEL CLICKS
    var pagePos;
    $(".mainNav-inner > ul > li > a").click(function(e) {
      if (overallWidth >= md) {
        // DESKTOP FUNCTIONS
        e.preventDefault();

        // only show .chapterId if "Local Resources" is clicked
        if ($(this).parent(".locator").length) {
          $(".chapterId").show();
        } else {
          $(".chapterId").hide();
        }

        currentChannel = $(this)
          .parent()
          .index();
        currentLevel = 0;

        $(".mainNav").addClass("on");

        $(".mainNav-inner > ul > li > a")
          .parent()
          .removeClass("on");
        $(this)
          .parent()
          .addClass("on");

        $(".mainNav-subContainer").addClass("on");
        $(".mainNav-subContainer").slideDown();
        $(".mainNavShade").addClass("on");
        pagePos = $("body").scrollTop();
        $("html, body").addClass("stuck");

        $(".mainNavSub .container .mainNavSubLeft").empty();
        // ALTERNATE FUNCTIONALITY FOR LOCATE AND SEARCH
        if ($(this)
          .closest('li')
          .hasClass('locator')
          ) { 
            $('.mainNavLocatorContainer > div')
              .clone(true)
              .appendTo('.mainNavSub .container .mainNavSubLeft')
              .addClass('on');
            $('.mainNavLocatorContainer > ul')
              .clone(true)
              .appendTo('.mainNavSub .container .mainNavSubLeft')
              .addClass('on');
        } else if (
          $(this)
            .closest("li")
            .hasClass("search")
        ) {
          $(".mainNavSearchContainer")
            .clone(true)
            .appendTo(".mainNavSub .container .mainNavSubLeft")
            .addClass("on");
        } else {
          var thisChild = $(this)
            .parent()
            .find("> ul");
          $(thisChild)
            .clone(true)
            .appendTo(".mainNavSub .container .mainNavSubLeft");
        }
        var thisImage = $(this)
          .next("div._advertisementContent")
          .clone();
        $(".mainNavSubRight").html(thisImage.html());

        $(".mainNavCrumbs .container .mainNavCrumbsInner").empty();

        var $crumbLink = $(this).clone();
        $crumbLink.appendTo(".mainNavCrumbs .container .mainNavCrumbsInner");
      }
    });

    // ADD CLASSES FOR LI'S WITH CHILDREN
    $(".mainNav li").each(function() {
      if ($("> ul", this).length) {
        $(this).addClass("hasChildren");
      }
    });

    // SUB LEVEL LINKS
    $(document).on("click", ".mainNavSub li a", function(e) {
      if (
        $(this)
          .parent()
          .find("> ul").length > 0
      ) {
        e.preventDefault();

        currentLevel = currentLevel + 1;

        var $breadCrumbLink = $(this).clone(true);

        $breadCrumbLink.appendTo(
          ".mainNavCrumbs .container .mainNavCrumbsInner"
        );
        $(".mainNavSubLeft > ul")
          .first()
          .stop()
          .animate(
            {
              "margin-left": "-" + currentLevel + "00%"
            },
            400,
            "easeInOutQuint"
          );
        $(this)
          .parent()
          .addClass("level" + currentLevel);
        $(this)
          .parent()
          .find("> ul")
          .clone(true)
          .appendTo(".mainNavSub .container .mainNavSubLeft");

        $(".mainNavGoBackLink").addClass("on");
      }
    });

    $(document).on("click", ".mainNavCrumbsInner a", function(e) {
      var returnDistance =
        $(".mainNavCrumbsInner a").length - 1 - $(this).index();

      e.preventDefault();
      $(this)
        .first()
        .nextAll()
        .remove();

      currentLevel = currentLevel - returnDistance;
      $(".mainNavSubLeft > ul")
        .first()
        .stop()
        .animate(
          {
            "margin-left": "-" + currentLevel + "00%"
          },
          400, 
          'easeInOutQuint', 
          function () {
            $('.mainNavSubLeft > ul')
              .slice(currentLevel + 1)
              .remove();
        });

      if (currentLevel == 0) {
        $(".mainNavGoBackLink").removeClass("on");
      }
    });

    // GO BACK LINK
    $("a.mainNavGoBackLink").click(function(e) {
      e.preventDefault();
      currentLevel = currentLevel - 1;

      if (currentLevel < 1) {
        $(this).removeClass("on");
      }
      $(".mainNavSubLeft > ul")
        .first()
        .stop()
        .animate(
          {
            marginLeft: "-" + currentLevel + "00%"
          },
          400,
          "easeInOutQuint",
          function() {
            $(".mainNavSubLeft > ul")
              .last()
              .remove();
          }
        );

      $(".mainNavCrumbs .container .mainNavCrumbsInner a:last-child").remove();
    });

    // SUB CONTAINER CLOSE
    $(".mainNavSubClose").click(function(e) {
      e.preventDefault();
      subContainerClose();
    });

    $(window).on("resize", function() {
      if (w != $(window).width()) {
        if (overallWidth >= md) {
          subContainerClose();
        }
        w = $(window).width();
      }
    });

    function subContainerClose() {
      $(".mainNav-inner > ul > li > a")
        .parent()
        .removeClass("on");
      $(".mainNav-subContainer").removeClass("on");
      $(".mainNav-subContainer").slideUp();
      $(".mainNavShade").removeClass("on");
      $(".mainNavGoBackLink").removeClass("on");
      $("html, body").removeClass("stuck");
      $(".mainNav").removeClass("on");
      $("body").scrollTop(pagePos);
    }
  });

  $(window).on("load", function() {});
})(jQuery);



$(document).ready(function() { 
  if (window.matchMedia('(max-width: 768px)').matches)
  {
      if ($('.articleRelated').length > 0) { 
          $('.articleRelated__menu').addClass('collapse');
          $('.articleRelated__toggle-title').addClass('shown');
          
      }
  }

});

